<div class="w-full py-3 px-2 sm:px-4">
  <!-- Stock Title Section -->
  <div class="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 mb-4">
    <div class="flex items-center justify-start gap-1 lg:gap-2 mb-0">
      <!-- Back Button SVG (clickable) -->
    <svg class="size-6 cursor-pointer" [routerLink]="['/report/raw-metal']" viewBox="0 0 24 24" fill="none"
        xmlns="http://www.w3.org/2000/svg">
    
        <mask id="mask0_848_1764" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
            <rect width="24" height="24" fill="#C19725" />
        </mask>
        <g mask="url(#mask0_848_1764)">
            <path d="M16 22L6 12L16 2L17.775 3.775L9.55 12L17.775 20.225L16 22Z" fill="#C19725" />
        </g>
    </svg>
      <img class="size-6 sm:size-8 lg:size-10" src="/assets/images/raw-metal/raw-metal.png" alt="Report" />
      <span class="font-semibold text-sm sm:text-base lg:text-xl text-444">Raw Metal List</span>
    </div>
    <div class="w-full md:w-auto">
      <a
        routerLink="/raw-metal/metal"
        class="block cursor-pointer px-3 py-1.5 text-xs sm:text-sm lg:text-base font-semibold text-white bg-c19725 border-2 border-c19725 hover:bg-[#fdffc6] hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-md text-center dark:bg-c19725 dark:hover:bg-[#fdffc6]"
      >
        Add New Raw Metal
      </a>
    </div>
  </div>

  <!-- Filters Row -->
  <div
    class="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4"
  >
    <!-- Inputs Grid (Rows, Search, Dates) -->
    <div
      class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 items-center justify-start gap-3 w-full lg:w-auto"
    >
      <!-- Search -->
      <div class="relative flex items-center gap-1 sm:gap-2">
        <label
          for="rowFilter"
          class="text-xs sm:text-sm font-medium text-gray-800 whitespace-nowrap"
        >
          Rows :
        </label>
        <select
          id="rowFilter"
          [(ngModel)]="visibleRowCount"
          (change)="updateVisibleRows()"
          class="w-full border border-dcdcdc rounded-[5px] p-1 text-xs sm:text-sm appearance-none !bg-none pr-6 focus:outline-none focus:ring-0 focus:border-c19725"
        >
          <option
            *ngFor="let count of [5, 10, 20, 30, 40, 50, 100]"
            [value]="count"
          >
            {{ count }}
          </option>
        </select>
        <div
          class="absolute inset-y-0 right-1.5 flex items-center pointer-events-none"
        >
          <svg
            width="10"
            height="5"
            viewBox="0 0 14 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.00004 7.00016L0.333374 0.333496H13.6667L7.00004 7.00016Z"
              fill="#C19725"
            />
          </svg>
        </div>
      </div>

      <div class="flex items-center gap-1 sm:gap-2">
        <label
          for="globalSearch"
          class="text-xs sm:text-sm font-medium text-gray-800 whitespace-nowrap"
        >
          Search :
        </label>
        <input
          id="globalSearch"
          type="text"
          [(ngModel)]="globalSearchText"
          (ngModelChange)="filterTable()"
          placeholder="Search all columns..."
          class="border border-dcdcdc rounded-[5px] px-3 py-1 text-xs sm:text-sm w-full lg:w-64 focus:outline-none focus:ring-0 focus:border-c19725"
          autocomplete="off"
        />
      </div>
       <!-- ================= FROM DATE ================= -->
  <div class="flex items-center gap-1 sm:gap-2">
    <label
      for="startDate"
      class="text-xs sm:text-sm font-medium text-gray-800 whitespace-nowrap"
    >
      From :
    </label>

    <input
      id="startDate"
      type="date"
      [(ngModel)]="startDate"
      (change)="filterTable()"
      class="w-full border border-dcdcdc rounded-[5px] px-3 py-1 text-xs sm:text-sm focus:outline-none focus:ring-0 focus:border-c19725"
    />
  </div>

  <!-- ================= TO DATE ================= -->
  <div class="flex items-center gap-1 sm:gap-2">
    <label
      for="endDate"
      class="text-xs sm:text-sm font-medium text-gray-800 whitespace-nowrap"
    >
      To :
    </label>

    <input
      id="endDate"
      type="date"
      [(ngModel)]="endDate"
      (change)="filterTable()"
      class="w-full border border-dcdcdc rounded-[5px] px-3 py-1 text-xs sm:text-sm focus:outline-none focus:ring-0 focus:border-c19725"
    />
  </div>
    </div>

    <!-- Buttons Row -->
    <div
      class="flex items-center flex-wrap justify-center md:justify-end gap-2 w-full lg:w-auto"
    >
      <div
      class="flex items-center gap-4 px-4 py-1.5 rounded-xl border border-[#C19725] bg-gradient-to-r from-[#fff7e6] to-[#fff1cc] shadow-sm flex-1 md:flex-none justify-center"
    >
      <span class="text-xs lg:text-sm font-medium text-[#7a5b12] whitespace-nowrap">
        Total Items :
      </span>
    
      <span
        class="text-C19725 font-bold text-sm lg:text-base"
      >
        {{ rawMetallist.length || 0 }}
      </span>
    </div>
      <!-- Download Buttons -->
      <button
        class="flex-1 md:flex-none text-[#F20707] border-1 border-[#F20707] bg-[#fff6f3] font-medium text-xs md:text-sm px-2 md:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
        (click)="downloadPDF()"
      >
         PDF
      </button>
      <button
        class="flex-1 md:flex-none text-[#029921] border-1 border-[#029921] bg-[#e6ffe6] font-medium text-xs md:text-sm px-2 md:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
        (click)="downloadExcel()"
      >
        Excel
      </button>
      <button
        class="flex-1 md:flex-none text-[#0720EC] border-1 border-[#0720EC] bg-[#E8E6FF] font-medium text-xs md:text-sm px-2 md:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
        (click)="downloadJSONAll()"
      >
        JSON
      </button>
      <button
        class="flex-1 md:flex-none text-[#00ad94] border-1 border-[#00ad94] bg-[#e5fffb] font-medium text-xs md:text-sm px-2 md:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
        (click)="downloadCSV()"
      >
         CSV
      </button>

      <div class="relative inline-block text-left flex-1 md:flex-none">
        <button
          (click)="toggleDropdown()"
          class="w-full text-[#B92185] border-1 border-[#B92185] bg-[#FFE1F5] font-medium text-xs md:text-sm px-2 md:px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
        >
          Visibility
        </button>

        <div
          *ngIf="showDropdown"
          class="absolute z-[100] mt-2 p-4 bg-white border rounded shadow-2xl right-0 sm:-left-24 w-64 max-h-80 overflow-y-auto"
        >
          <p class="font-semibold mb-2">Select Columns to Show:</p>

          <!-- Checkbox list -->
          <label
            *ngFor="let field of selectedFields"
            class="block text-sm mb-1"
          >
            <input
              type="checkbox"
              [(ngModel)]="field.selected"
              autocomplete="off"
            />
            {{ field.label }}
          </label>

          <!-- Button actions -->
          <div class="mt-3 flex flex-col gap-2">
            <button
              (click)="selectAllFields()"
              class="text-sm text-blue-600 hover:underline text-left"
            >
              Select All
            </button>
            <button
              (click)="deselectAllFields()"
              class="text-sm text-red-800 hover:underline text-left"
            >
              Deselect All
            </button>
            <button
              (click)="restoreColumnSelection()"
              class="text-sm text-gray-600 hover:underline text-left"
            >
              Restore Columns
            </button>

            <!-- Apply button -->
            <button
              (click)="applyColumnSelection()"
              class="mt-2 bg-blue-600 text-white text-xs md:text-sm px-1 md:px-4 py-2 rounded-[5px] transition"
            >
              Apply
            </button>
          </div>
        </div>
      </div>
      <button
        (click)="printTable()"
        class="flex-1 md:flex-none text-[#5606b6] border-1 border-[#5606b6] bg-[#ecddff] font-medium text-xs md:text-sm px-4 py-2 rounded-[5px] hover:bg-white hover:shadow-lg transition"
      >
        Print
      </button>
    </div>
  </div>

  <!-- Table layout -->
  <div class="overflow-x-auto whitespace-nowrap hide-scrollbar border border-[#D9D9D9] rounded-md mt-6">
    <table
      class="w-full table border-collapse border-spacing-0 bg-white overflow-hidden"
    >
      <thead class="bg-[#F2F2F2] text-444 text-xs sm:text-sm lg:text-base">
        <tr>
          <th
            class="p-2 font-medium text-center border-r border-444 last:border-r-0"
          >
            No.
          </th>
          <th
            *ngFor="let field of selectedFields"
            [hidden]="!field.selected"
            class="p-2 font-medium text-left border-r border-444 last:border-r-0"
          >
            <div class="flex flex-col gap-1 w-32 sm:w-40">
              <!-- Search Input -->
              <input
                type="text"
                [(ngModel)]="searchValues[field.key]"
                (click)="$event.stopPropagation()"
                (ngModelChange)="filterTable()"
                [attr.placeholder]="'Search ' + field.label"
                class="border border-dcdcdc p-1 rounded-[5px] text-xs w-full focus:outline-none focus:border-c19725 font-normal"
                [autofocus]="field.key === 'st_code'"
                autocomplete="off"
              />

              <!-- Sortable Label -->
              <div
                class="text-xs font-medium text-gray-700 flex items-center gap-1 cursor-pointer select-none"
                (click)="sortBy(field.key)"
              >
                {{ field.label }}
                <svg
                  *ngIf="sortKey === field.key"
                  class="w-3 h-3"
                  viewBox="0 0 24 24"
                >
                  <path
                    *ngIf="sortDirection === 'asc'"
                    d="M12 8l6 6H6z"
                    fill="currentColor"
                  />
                  <path
                    *ngIf="sortDirection === 'desc'"
                    d="M12 16l-6-6h12z"
                    fill="currentColor"
                  />
                </svg>
              </div>
            </div>
          </th>
          <th
            class="p-2 font-medium text-center border-r border-444 last:border-r-0"
          >
            Action
          </th>
        </tr>
      </thead>
      <tbody class="text-xs sm:text-sm lg:text-base">
        <tr *ngFor="let item of paginatedStockList; let i = index" class="hover:bg-gray-50 transition-colors">
          <!-- Serial Number -->
          <td class="p-2 border-r border-b border-[#D9D9D9] text-center">
            {{ (currentPage - 1) * itemsPerPage + i + 1 }}
          </td>

          <!-- Dynamic Fields -->
          <ng-container *ngFor="let field of selectedFields">
  <td *ngIf="field.selected" class="p-2 border-r border-b border-[#D9D9D9]">

    <!-- IMAGE COLUMN -->
    <ng-container *ngIf="field.isImage; else nonImage">
      <div class="flex justify-center">
        <img
          [src]="item.st_image1 || item.st_image2 || '/assets/images/no-image.png'"
          class="w-10 h-10 sm:w-12 sm:h-12 object-contain rounded border"
          alt="Product Image"
        />
      </div>
    </ng-container>

    <!-- NON-IMAGE COLUMNS -->
    <ng-template #nonImage>

      <!-- SIZE SPECIAL CASE -->
      <ng-container *ngIf="field.key === 'st_item_size'; else normalField">
        {{
          item['st_item_size'] && item['st_size_type']
            ? formatNumber(item['st_item_size']) + ' ' + item['st_size_type']?.toLowerCase()
            : item['st_item_size']
              ? formatNumber(item['st_item_size'])
              : '-'
        }}
      </ng-container>

      <!-- NORMAL TEXT -->
      <ng-template #normalField>
        {{ formatFieldValue(item, field) }}
      </ng-template>

    </ng-template>

  </td>
</ng-container>


          <!-- Action Buttons -->
          <td class="p-2 border-r border-b border-[#D9D9D9] text-center">
            <div class="flex items-center justify-center gap-1 sm:gap-2">
              <!-- view button -->
              <button
                aria-label="View Firm Details"
                class="icon-btn text-blue-600 hover:scale-110 hover:text-blue-800 transition"
                (click)="openPackagingDetails(item.st_id)"
                title="View"
              >
                <svg
                  class="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <!-- Eye icon with a more rounded, modern style -->
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 4.5C7.305 4.5 3.133 8.118 1.5 12c1.633 3.882 5.805 7.5 10.5 7.5s8.867-3.618 10.5-7.5c-1.633-3.882-5.805-7.5-10.5-7.5z"
                  />
                  <circle
                    cx="12"
                    cy="12"
                    r="3"
                    stroke="currentColor"
                    stroke-width="2"
                    fill="none"
                  />
                </svg>
              </button>

              <!-- View/Edit Button -->
              <button
                class="cursor-pointer transition hover:scale-110"
                routerLink="/raw-metal/metal/{{ item.st_id }}"
              >
                <svg
                  class="w-4 h-4 sm:w-5 sm:h-5"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.552 4.332L19.5109 8.29075M3.2815 16.452L2.75 21.25L7.54788 20.7185L21.25 7.00912V5.39287L18.6071 2.75H16.9909L3.2815 16.452Z"
                    stroke="#C19725"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14.7166 9.23962L8.10638 15.8499"
                    stroke="#C19725"
                    stroke-miterlimit="5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>

              <!-- Delete Button -->
              <button
                class="cursor-pointer p-1 transition hover:scale-110"
                (click)="deleteMetal(item.st_id)"
              >
                <svg
                  class="w-4 h-4 sm:w-5 sm:h-5"
                  viewBox="0 0 24 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 12.5V17.5"
                    stroke="#BB0000"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14 12.5V17.5"
                    stroke="#BB0000"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M4 7.5H20"
                    stroke="#BB0000"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M6 10.5V18.5C6 20.1569 7.34315 21.5 9 21.5H15C16.6569 21.5 18 20.1569 18 18.5V10.5"
                    stroke="#BB0000"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9 5.5C9 4.39543 9.89543 3.5 11 3.5H13C14.1046 3.5 15 4.39543 15 5.5V7.5H9V5.5Z"
                    stroke="#BB0000"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Pagination -->
  <div
    class="flex flex-col sm:flex-row items-center justify-between border-t border-gray-200 bg-white py-3 gap-4"
  >
    <div class="text-xs text-gray-500 italic">
      Page {{currentPage}} of {{totalPages}}
    </div>
    <div class="flex sm:flex-1 sm:items-center sm:justify-end">
      <div>
        <nav
          class="isolate inline-flex gap-1 sm:gap-2 -space-x-px rounded-md shadow-xs"
          aria-label="Pagination"
        >
          <button
            (click)="goToPreviousPage()"
            [disabled]="currentPage === 1"
            class="relative inline-flex items-center justify-center w-8 h-8 md:w-9 md:h-9 rounded-[5px] text-c19725 ring-1 ring-c19725 ring-inset hover:bg-[#f6f1cb] focus:z-20 focus:outline-offset-0 disabled:opacity-30 disabled:pointer-events-none"
          >
            <span class="sr-only">Previous</span>
            <svg
              class="size-5 md:size-6"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
              data-slot="icon"
            >
              <path
                fill-rule="evenodd"
                d="M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
          
          <div class="flex gap-1 overflow-x-auto max-w-[150px] sm:max-w-none no-scrollbar">
            <button
              (click)="goToPage(1)"
              [class.bg-c19725]="currentPage === 1"
              [class.text-white]="currentPage === 1"
              class="relative z-10 inline-flex items-center justify-center min-w-[32px] md:min-w-[36px] h-8 md:h-9 rounded-[5px] text-sm font-normal text-c19725 ring-1 ring-c19725 ring-inset focus:z-20 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-c19725"
            >
              1
            </button>
            <button
              (click)="goToPage(2)"
              [class.bg-c19725]="currentPage === 2"
              [class.text-white]="currentPage === 2"
              class="relative inline-flex items-center justify-center min-w-[32px] md:min-w-[36px] h-8 md:h-9 rounded-[5px] text-sm font-normal text-c19725 ring-1 ring-c19725 ring-inset hover:bg-[#f6f1cb] focus:z-20 focus:outline-offset-0"
            >
              2
            </button>
            <span
              class="relative inline-flex items-center justify-center w-8 h-8 md:w-9 md:h-9 rounded-[5px] text-sm font-normal text-gray-700 focus:outline-offset-0"
              >...</span
            >
            <button
              (click)="goToPage(totalPages)"
              [class.bg-c19725]="currentPage === totalPages"
              [class.text-white]="currentPage === totalPages"
              class="relative inline-flex items-center justify-center min-w-[32px] md:min-w-[36px] h-8 md:h-9 rounded-[5px] text-sm font-normal text-c19725 ring-1 ring-c19725 ring-inset hover:bg-[#f6f1cb] focus:z-20 focus:outline-offset-0"
            >
              {{ totalPages }}
            </button>
          </div>

          <button
            (click)="goToNextPage()"
            [disabled]="currentPage === totalPages"
            class="relative inline-flex items-center justify-center w-8 h-8 md:w-9 md:h-9 rounded-[5px] text-c19725 ring-1 ring-c19725 ring-inset hover:bg-[#f6f1cb] focus:z-20 focus:outline-offset-0 disabled:opacity-30 disabled:pointer-events-none"
          >
            <span class="sr-only">Next</span>
            <svg
              class="size-5 md:size-6"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
              data-slot="icon"
            >
              <path
                fill-rule="evenodd"
                d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        </nav>
      </div>
    </div>
  </div>
</div>